<label class="a-checkbox control control-checkbox" [class.is-disabled]="isDisabled">
    <span [innerHTML]="label"></span>
    <input type="checkbox" [checked]="control.value" (change)="onChange($event)">
    <div class="a-checkbox-indicator" [class.has-error]="control.invalid && isSubmitted"></div>
</label>